import {
  GetAllEventError,
  ETLConfigGeneratorError,
  GetETLConfigGeneratorError,
} from 'modules/event/eventService';
import { matchPI } from '@rogu/adt';

function errorHandler(error: GetAllEventError) {
  return matchPI(error)({
    BAD_REQUEST: (e) => e.error.detail,
    DECODE_ERROR: (e) => e.message,
    INTERNAL_ERROR: (e) => e.error.detail,
    SERVER_ERROR: (e) => e.error.detail,
    UNKNOWN_ERROR: (e) => e.error?.message,
    _: () => 'unknwon error',
  });
}

function errorHandlerETLConfig(error: ETLConfigGeneratorError) {
  return matchPI(error)({
    DECODE_ERROR: (e) => e.message,
    UNKNOWN_ERROR: (e) => e.error?.message,
    SERVER_ERROR: (e) => e.error.detail,
    INTERNAL_ERROR: (e) => e.error.detail,
    BAD_REQUEST_INVALID_ETL_CONFIG: (e) => e.error.detail,
    BAD_REQUEST_INVALID_USER_TOKEN: (e) => e.error.detail,
    _: () => 'unknwon error',
  });
}

function errorGetETLConfig(error: GetETLConfigGeneratorError) {
  return matchPI(error)({
    DECODE_ERROR: (e) => e.message,
    UNKNOWN_ERROR: (e) => e.error?.message,
    SERVER_ERROR: (e) => e.error.detail,
    INTERNAL_ERROR: (e) => e.error.detail,
    _: () => 'unknwon error',
  });
}

export { errorHandler, errorHandlerETLConfig, errorGetETLConfig };
